import Service from './abstract';

class Health extends Service {
    constructor () {
        super('health');
    }

    get (service) {
        const options = {
            url: `/${service}/health`,
            qs: {
                tag: true,
                with: 'dependencies'
            }
        };

        return super.get(options);
    }
}

export default new Health();
